/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/*eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, createStyles, IconButton, LinearProgress, makeStyles, Table as MUITable, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, withStyles } from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {
  KeyboardDatePicker, DatePicker, DateTimePicker, TimePicker
} from '@material-ui/pickers';
import clsx from 'clsx';
import { Moment } from 'moment';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useAsyncDebounce, useExpanded, useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import ListTableLoader from 'src/components/Loaders/ListTableLoader';
import useSettings from 'src/hooks/useSettings';
import { Theme } from 'src/theme';
import { displayDateFormat, displayDateTimeFormat } from 'src/utils/dates';
import type { TableFilter } from 'src/utils/tableQuery';
import NoRecords from './NoRecords';
import SelectBox from './SelectBox';

declare module 'react-table' {
  // take this file as-is, or comment out the sections that don't apply to your plugin configuration

  export interface TableOptions<D extends object>
    extends UseExpandedOptions<D>,
    UseFiltersOptions<D>,
    UseGlobalFiltersOptions<D>,
    UseGroupByOptions<D>,
    UsePaginationOptions<D>,
    UseResizeColumnsOptions<D>,
    UseRowSelectOptions<D>,
    UseRowStateOptions<D>,
    UseSortByOptions<D>,
    // note that having Record here allows you to add anything to the options, this matches the spirit of the
    // underlying js library, but might be cleaner if it's replaced by a more specific type that matches your
    // feature set, this is a safe default.
    Record<string, any> { }

  export interface Hooks<D extends object>
    extends UseExpandedHooks<D>,
    UseGroupByHooks<D>,
    UseRowSelectHooks<D>,
    UseSortByHooks<D> { }

  export interface TableInstance<D extends object>
    extends UseColumnOrderInstanceProps<D>,
    UseExpandedInstanceProps<D>,
    UseFiltersInstanceProps<D>,
    UseGlobalFiltersInstanceProps<D>,
    UseGroupByInstanceProps<D>,
    UsePaginationInstanceProps<D>,
    UseRowSelectInstanceProps<D>,
    UseRowStateInstanceProps<D>,
    UseSortByInstanceProps<D> { }

  export interface TableState<D extends object>
    extends UseColumnOrderState<D>,
    UseExpandedState<D>,
    UseFiltersState<D>,
    UseGlobalFiltersState<D>,
    UseGroupByState<D>,
    UsePaginationState<D>,
    UseResizeColumnsState<D>,
    UseRowSelectState<D>,
    UseRowStateState<D>,
    UseSortByState<D> { }

  export interface ColumnInterface<D extends object>
    extends UseFiltersColumnOptions<D>,
    UseGlobalFiltersColumnOptions<D>,
    UseGroupByColumnOptions<D>,
    UseResizeColumnsColumnOptions<D>,
    UseSortByColumnOptions<D> { }

  export interface ColumnInstance<D extends object>
    extends UseFiltersColumnProps<D>,
    UseGroupByColumnProps<D>,
    UseResizeColumnsColumnProps<D>,
    UseSortByColumnProps<D> { }

  export interface Cell<D extends object, V = any>
    extends UseGroupByCellProps<D>,
    UseRowStateCellProps<D> { }

  export interface Row<D extends object>
    extends UseExpandedRowProps<D>,
    UseGroupByRowProps<D>,
    UseRowSelectRowProps<D>,
    UseRowStateRowProps<D> { }

  export interface UseTableColumnProps<D extends object> {
    filterable: boolean;
    Filter: ReactNode;
    sortable: boolean;
  }
}

interface MUIReactTableProps {
  className?: string;
  data?: any;
  columns?: any;
  requestData?: any;
  loading?: boolean;
  pageCount?: number;
  totalCount?: number;
  manual?: boolean;
  noRecords?: boolean;
  refreshing?: boolean;
  name?: string | null;
  rowsPerPageOptions?: number[];
  initialFilters?: TableFilter[];
  renderRowSubComponent?: (row: any) => ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  queryField: {
    width: 500
  },
  bulkOperations: {
    position: 'relative'
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    marginTop: 6,
    position: 'absolute',
    width: '100%',
    zIndex: 2,
    backgroundColor: theme.palette.background.default
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      fontSize: 12
    }
  },
  fontSizeSmall: {
    fontSize: '0.875rem'
  },
  filterDD: {
    minWidth: 60,
    marginTop: 0
  },
  filterDDSelect: {
    marginTop: '0!important'
  },
  hover: {
    backgroundColor: 'blue'
  },
  // container: {
  //   maxHeight: "51vh",
  // },
}));

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
)(TableRow);

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, setFilter }
}) {
  const classes = useStyles();
  return (
    <TextField
      value={filterValue || ''}
      onChange={e => { setFilter(e.target.value || undefined); }}
      placeholder={'Search'}
      style={{ width: '80%', minWidth: '80px' }}
      InputProps={{
        classes: {
          input: classes.input
        }
      }}
    />
  );
}

// This is a custom filter UI for selecting
// a unique option from a list
export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, options: selectBoxOptions, Header },
}) {
  const classes = useStyles();
  const [val, setVal] = useState<string>(
    filterValue === undefined || filterValue === '' ? 'all' : String(filterValue),
  );
  return (
    <SelectBox
      handleChange={e => {
        const val = e.target.value.toString();
        let filterVal = val;
        if (val === 'all') {
          filterVal = '';
        }
        setVal(val || '');
        setFilter(filterVal || undefined);
      }}
      items={selectBoxOptions}
      name={`${Header}Filter`}
      value={val}
      firstOption={{ id: 'all', name: 'All' }}
      className={classes.filterDD}
      innerClassName={classes.filterDDSelect}
      variant={'standard'}
      style={{ width: '80%', minWidth: '80px' }}
    />
  );
}

// This is a custom filter UI for date filter
// a unique option from a list
export function DateColumnFilter({
  column: { filterValue, setFilter, Header },
  ...rest
}) {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [invalidFormat, setInvalidFormat] = React.useState(false);
  const handleDateChange = (date: Moment | null, dateVal: string | null) => {
    // Set invalid format flag to show "Invalid Date Format" error message.
    setInvalidFormat(!!dateVal && dateVal.replace('_','').length === 10 && !date.isValid())

    if (date !== null && date.isValid()) {
      setFilter(date.format('YYYY-MM-DD') || undefined);
    } else {
      const filterValue = '';
      setFilter(filterValue || undefined);
    }
    setSelectedDate(date);
  };
  return (
    <Box minWidth="140px">
      <KeyboardDatePicker
        disableToolbar
        format="YYYY-MM-DD"
        margin="normal"
        id="date-picker-dialog"
        value={selectedDate}
        onChange={handleDateChange}
        name={`${Header}Filter`}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        placeholder="yyyy-mm-dd"
        inputProps={{className: classes.input}}
        invalidDateMessage={invalidFormat ? 'Invalid Date Format' : 'Incomplete Date'}
        className={classes.filterDD}
        showTodayButton={true}
        clearable={true}
        style={{ margin: 0 }}
        {...rest}
      />
    </Box>
  );
}

function DatePickerComponent({ value, onChangeHandler, name, placeholder, ...rest }) {
  const classes = useStyles();
  return (
    <DatePicker
      format={displayDateFormat}
      margin="normal"
      value={value}
      onChange={onChangeHandler}
      name={name}
      className={classes.filterDD}
      showTodayButton={true}
      clearable={true}
      style={{ margin: 0, width: '5rem' }}
      autoOk={true}
      placeholder={placeholder}
      InputProps={{
        classes: {
          input: clsx(classes.input, classes.fontSizeSmall)
        }
      }}
      {...rest}
    />
  );
}

// This is a custom UI for our Date Range
// filter. It uses two date picker boxes and filters rows to
// ones that have values between the two.
export function DateRangeColumnFilter({
  column: { filterValue = { from: null, to: null }, setFilter, Header }
}) {
  return (
    <Box minWidth={filterValue.from || filterValue.to ? '11rem' : '5rem'} >
      <DatePickerComponent
        value={filterValue.from || null}
        onChangeHandler={(val: Moment | null) => {
          setFilter((old = { from: null, to: null }) => ({ from: val?.format(displayDateFormat) || null, to: old.to }));
        }}
        name={`${Header}ToFilter`}
        placeholder={'From'}
      />
      {filterValue.from || filterValue.to ? <Box component={'span'}>
        <Box component={'span'} ml={1} mr={1}>_</Box>
        <DatePickerComponent
          value={filterValue.to || null}
          onChangeHandler={(val: Moment | null) => {
            setFilter((old = { from: null, to: null }) => ({ from: old.from, to: val?.format(displayDateFormat) || null }));
          }}
          name={`${Header}FromFilter`}
          placeholder={'To'}
        />
      </Box> : ''}
    </ Box>
  );
}

// This is a custom UI for our Time Range
// filter. It uses two date picker boxes and filters rows to
// ones that have values between the two.
export function TimeRangeColumnFilter({
  column: { filterValue = [null, null], setFilter, Header }
}) {
  return (
    <Box minWidth={filterValue[0] || filterValue[1] ? '9rem' : '4rem'} >
      <TimePickerComponent
        value={filterValue[0] || null}
        onChangeHandler={(val: string | null) => {
          setFilter((old = []) => [val || null, old[1]]);
        }}
        name={`${Header}ToFilter`}
        placeholder={'From'}
      />
      {filterValue[0] || filterValue[1] ? <Box component={'span'}>
        <Box component={'span'} ml={1} mr={1}>_</Box>
        <TimePickerComponent
          value={filterValue[1] || null}
          onChangeHandler={(val: string | null) => {
            setFilter((old = []) => [old[0], val || null]);
          }}
          name={`${Header}FromFilter`}
          placeholder={'To'}
        />
      </Box> : ''}
    </ Box>
  );
}

function TimePickerComponent({ value, onChangeHandler, name, placeholder }) {
  const classes = useStyles();
  return (
    <TimePicker
      margin="normal"
      value={value}
      onChange={onChangeHandler}
      name={name}
      className={classes.filterDD}
      showTodayButton={true}
      clearable={true}
      style={{ margin: 0, width: '4rem' }}
      autoOk={true}
      placeholder={placeholder}
      InputProps={{
        classes: {
          input: clsx(classes.input, classes.fontSizeSmall)
        }
      }}
    />
  );
}

function DateTimePickerComponent({ value, onChangeHandler, name, placeholder }) {
  const classes = useStyles();
  return (
    <DateTimePicker
      format={displayDateTimeFormat}
      margin="normal"
      value={value}
      onChange={onChangeHandler}
      name={name}
      className={classes.filterDD}
      showTodayButton={true}
      clearable={true}
      style={{ margin: 0, width: '8.5rem' }}
      autoOk={true}
      placeholder={placeholder}
      InputProps={{
        classes: {
          input: clsx(classes.input, classes.fontSizeSmall)
        }
      }}
    />
  );
}

// This is a custom UI for our Date Time Range
// filter. It uses two date picker boxes and filters rows to
// ones that have values between the two.
export function DateTimeRangeColumnFilter({
  column: { filterValue = { from: null, to: null }, setFilter, Header }
}) {
  return (
    <Box minWidth={filterValue.from || filterValue.to ? '20rem' : '8.5px'} >
      <DateTimePickerComponent
        value={filterValue.from || null}
        onChangeHandler={(val: Moment | null) => {
          setFilter((old = { from: null, to: null }) => ({ from: val?.format(displayDateTimeFormat) || null, to: old.to }));
        }}
        name={`${Header}ToFilter`}
        placeholder={'From'}
      />
      {filterValue.from || filterValue.to ? <Box component={'span'}>
        <Box component={'span'} ml={1} mr={1}>_</Box>
        <DateTimePickerComponent
          value={filterValue.to || null}
          onChangeHandler={(val: Moment | null) => {
            setFilter((old = { from: null, to: null }) => ({ from: old.from, to: val?.format(displayDateTimeFormat) || null }));
          }}
          name={`${Header}FromFilter`}
          placeholder={'To'}
        />
      </Box> : ''}
    </ Box>
  );
}

// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two
export function NumberRangeColumnFilter({
  column: { filterValue = [], setFilter, id }, column
}) {
  const classes = useStyles();
  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <TextField
        value={filterValue[0] || ''}
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [
            val ? parseInt(val, 10) : undefined,
            old[1]
          ]);
        }}
        type="number"
        placeholder={'Min'}
        InputProps={{
          classes: {
            input: classes.input
          }
        }}
        style={{
          width: '50px',
          marginRight: '0.5rem',
        }}
      />
      to
      <TextField
        value={filterValue[1] || ''}
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [
            old[0],
            val ? parseInt(val, 10) : undefined
          ]);
        }}
        type="number"
        placeholder={'max'}
        InputProps={{
          classes: {
            input: classes.input
          }
        }}
        style={{
          width: '50px',
          marginLeft: '0.5rem'
        }}
      />
    </div>
  );
}

// Be sure to pass our updateMyData and the skipPageReset option
function Table({ columns, data, updateMyData, skipPageReset, classes, manual, onFetchData, pageCount: controlledPageCount, totalCount, noRecords, refreshing, name, rowsPerPageOptions = [5, 10, 25, 50, 100, 500], initialFilters, renderRowSubComponent }) {
  const { settings, saveSettings } = useSettings();
  const { tables = { sizes: {} } } = settings;
  const { sizes: { [name]: savedRowsPerPage } } = tables;

  const finalColumns = React.useMemo(() => {
    if (!renderRowSubComponent) return columns;
    return [
      {
        id: 'expander',
        Header: () => null,
        width: 36,
        filterable: false,
        sortable: false,
        Cell: ({ row }: any) => (
          <IconButton size="small" {...row.getToggleRowExpandedProps()} aria-label="toggle row">
            {row.isExpanded ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
          </IconButton>
        ),
      },
      ...columns,
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, renderRowSubComponent]);

  const columnsLen = finalColumns?.length;
  const rangeFilters = React.useMemo(
    () => {
      return finalColumns?.filter(col => col.filter === 'range').map(col => col.accessor);
    }, [columnsLen]
  );

  const filterTypes = React.useMemo(() => ({}), []);

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  let options: any = {
    columns: finalColumns,
    data,
    defaultColumn,
    filterTypes,
    manual,
    onFetchData,
    manualFilters: manual,
    // use the skipPageReset option to disable page resetting temporarily
    autoResetPage: !skipPageReset,
    // updateMyData isn't part of the API, but
    // anything we put into these options will
    // automatically be available on the instance.
    // That way we can call this function from our
    // cell renderer!
    updateMyData,
  };
  if (manual) {
    options = {
      ...options,
      initialState: { pageIndex: 0, filters: initialFilters ?? [] },
      manualSortBy: true,
      disableSortRemove: true,
      disableMultiSort: true,
      manualPagination: manual, // Tell the usePagination
      // hook that we'll handle our own data fetching
      // This means we'll also have to provide our own
      // pageCount.
      pageCount: controlledPageCount,
    };
  }
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    // canPreviousPage,
    // canNextPage,
    // pageOptions,
    // pageCount,
    gotoPage,
    // nextPage,
    // previousPage,
    setPageSize,
    // setPage,
    state: { pageIndex, pageSize, filters, sortBy },
    // state,
    // preGlobalFilteredRows,
    // setGlobalFilter,

  } = useTable(
    options,
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    useExpanded,
    usePagination
  );

  const sortByStr = JSON.stringify(sortBy);

  const [nextPageNumber, setNextPageNumber] = useState<number>(pageIndex ?? 0);
  const debounceTheFetching = useAsyncDebounce(({ pageIndex, pageSize, filters, sortBy }) => {
    const typedFilters = filters.map(f => {
      if (rangeFilters.includes(f.id))
        return { ...f, type: 'range' };
      else
        return { ...f, type: 'includes' };
    });
    onFetchData({ pageIndex, pageSize, filters: typedFilters, sortBy });
  }, 250);

  useEffect(() => {
    if (manual) {
      debounceTheFetching({ pageIndex: nextPageNumber, pageSize: savedRowsPerPage || pageSize, filters, sortBy });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, savedRowsPerPage, JSON.stringify(filters), nextPageNumber, sortByStr]);

  // Render the UI for your table
  return (
    // <PerfectScrollbar>
    <Box>
      <TableContainer className={classes.container}>
        <MUITable stickyHeader aria-label="sticky table" size="small" {...getTableProps()}>
          {refreshing ? <TableRow key={-1}>
            <TableCell style={{ padding: '0' }} colSpan={headerGroups[0]?.headers.length}>
              <Box sx={{ width: '100%' }}>
                <LinearProgress style={{ height: '2px' }} />
              </Box >
            </TableCell>
          </TableRow> : ''}
          <TableHead>
            {headerGroups.map((headerGroup, i) => {
              const hasFilterables = headerGroup.headers.some(column => column.filterable);
              return <TableRow key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => {
                  return <TableCell key={i} width={column.width}>
                    {column.sortable
                      ? <Box component="span" {...column.getHeaderProps(column.getSortByToggleProps())} title={`Sort By ${column.Header}`}>
                        {column.render('Header')}
                        {column.isSorted ? (column.isSortedDesc ? <ArrowDownwardIcon fontSize='small' style={{ marginBottom: '-4px' }} /> : <ArrowUpwardIcon fontSize='small' style={{ marginBottom: '-4px' }} />) : ''}
                      </Box>
                      : column.render('Header')
                    }
                    {hasFilterables ? <>
                      <br />
                      {column.filterable ? column.render('Filter') : <Box height={32} />}
                    </> : ''}
                  </TableCell>;
                })}
              </TableRow>;
            })}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {noRecords ?
              <StyledTableRow key={0}>
                <TableCell colSpan={headerGroups[0]?.headers.length}><NoRecords text="No Records Found" height={100} variant={'h3'} color={'textSecondary'} /></TableCell>
              </StyledTableRow> :
              page.map((row, i) => {
                prepareRow(row);
                const uniqueKey = `row_${row.id}`;
                return (
                  <React.Fragment key={uniqueKey}>
                    <StyledTableRow hover {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        return <TableCell 
                        style={{backgroundColor:(cell?.column?.Header == 'Name' && row?.values?.ProductName?.props?.value == 'UNKNOWN')?'hsla(360, 75%, 54%, 0.75)':''}}
                        {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>;
                      })}
                    </StyledTableRow>
                    {renderRowSubComponent && row.isExpanded && (
                      <TableRow>
                        <TableCell colSpan={row.cells.length} style={{ paddingTop: 0, paddingBottom: 0 }}>
                          {renderRowSubComponent(row)}
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                );
              })}
          </TableBody>
        </MUITable>
      </TableContainer>

      <TablePagination
        component="div"
        count={manual ? totalCount : data.length}
        page={nextPageNumber}
        onPageChange={(e, pageNo) => {
          gotoPage(pageNo); // This will help for client side pagination.
          setNextPageNumber(pageNo); // This is for server side pagination.
        }}
        rowsPerPage={savedRowsPerPage || pageSize}
        onRowsPerPageChange={(e) => {
          setPageSize(Number(e.target.value));
          setNextPageNumber(0);
          const { tables = { sizes: {} } } = settings;
          const { sizes: prevSizes = {} } = tables;
          const updatedTables = { ...tables, sizes: { ...prevSizes, [name]: Number(e.target.value) } };
          saveSettings({ ...settings, tables: updatedTables });
        }}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    </Box>
    // </PerfectScrollbar>
  );
}

/**
 * 
 * This will render React Table with MUI.
 * No need pageCount and totalCount if listing is client side.
 * 
 * @param props
 * @returns JSX
 */
const MUIReactTable: FC<MUIReactTableProps> = ({
  className,
  columns,
  data,
  loading,
  requestData,
  pageCount = null, // Number of pages
  totalCount = null,
  manual = false,
  noRecords = false,
  refreshing = false,
  name = null,
  rowsPerPageOptions = [5, 10, 25, 50, 100, 500],
  initialFilters,
  renderRowSubComponent,
  ...rest
}) => {
  const [initialData, setData] = React.useState(data);

  const [skipPageReset, setSkipPageReset] = React.useState(manual);

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    if (!manual) {
      setSkipPageReset(true);
    }
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  React.useEffect(() => {
    setData(data);
    if (!manual) {
      setSkipPageReset(false);
    }
  }, [data]);

  // Let's add a data resetter/randomizer to help
  // illustrate that flow...
  // const resetData = () => setData(originalData)
  const classes = useStyles();
  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      {loading ? <ListTableLoader /> :
        <Table
          manual={manual}
          columns={columns}
          data={initialData}
          updateMyData={updateMyData}
          skipPageReset={skipPageReset}
          classes={classes}
          onFetchData={requestData}
          // onFetchData={this.handleFetchData}
          pageCount={pageCount}
          totalCount={totalCount}
          noRecords={noRecords}
          refreshing={refreshing}
          name={name}
          rowsPerPageOptions={rowsPerPageOptions}
          initialFilters={initialFilters}
          renderRowSubComponent={renderRowSubComponent}
        />
      }
    </Card>
  );
};

export default MUIReactTable;
